<button type="button" (click)="onClick($event)" class="btn btn-success followup-btn">{{label}}</button>